import React, { useMemo } from "react";
import {
  BooleanField,
  DropdownField,
  EncryptedInlineBinaryField,
  ListField,
  NumberField,
  TextField
} from "components/configurationforms";
import useServerText from "util/serverText";
const ConfigurationFormField = ({
  typeName,
  configField,
  configKey,
  configValue = void 0,
  dirty = false,
  autoFocus = false,
  onChange
}) => {
  const serverText = useServerText();
  const field = useMemo(
    () => ({
      ...configField,
      human_name: serverText(configField.human_name),
      description: serverText(configField.description)
    }),
    [configField, serverText]
  );
  const elementKey = `${typeName}-${configKey}`;
  switch (field.type) {
    case "text":
      return /* @__PURE__ */ React.createElement(
        TextField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field,
          value: configValue,
          dirty,
          onChange,
          autoFocus
        }
      );
    case "number":
      return /* @__PURE__ */ React.createElement(
        NumberField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field,
          value: configValue,
          onChange,
          autoFocus
        }
      );
    case "boolean":
      return /* @__PURE__ */ React.createElement(
        BooleanField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field,
          value: configValue,
          onChange,
          autoFocus
        }
      );
    case "dropdown":
      return /* @__PURE__ */ React.createElement(
        DropdownField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field,
          value: configValue,
          onChange,
          autoFocus,
          addPlaceholder: true
        }
      );
    case "list":
      return /* @__PURE__ */ React.createElement(
        ListField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field,
          value: configValue,
          onChange,
          autoFocus
        }
      );
    case "inline_binary":
      return /* @__PURE__ */ React.createElement(
        EncryptedInlineBinaryField,
        {
          key: elementKey,
          typeName,
          title: configKey,
          field,
          value: configValue,
          dirty,
          onChange,
          autoFocus
        }
      );
    default:
      return null;
  }
};
export default ConfigurationFormField;
